import React from "react";
import { BaseProps } from "../../index";
import { HTMLDivProps } from "../../../constant/type";

export default interface TextProps extends BaseProps, HTMLDivProps {
  children: React.ReactNode | string;
  type?: TextType;
  as?: React.ElementType;
  customAs?: React.ElementType;
  tone?: number;
  color?: string;
  bold?: boolean;
  fontWeight?: string | number;
  anchor?: boolean;
  font?: string;
  lineHeight?: number;
  size?: number;
  inline?: boolean;
  align?: string;
  noClick?: boolean;
  underline?: boolean;
  underlineColor?: string;
  eclipse?: boolean;
  maxWidth?: number | string;
}

export enum TextType {
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  H4 = "h4",
  H5 = "h5",
  H6 = "h6",
  BODY = "body",
  BODY2 = "body2",
  SUB_BODY = "sub_body",
}
